import { CUSTOMER_SEGMENTATION_GRANULARITY_VIEWS, CUSTOMER_SEGMENTATION_TYPES } from '#shared/filters.model.js';
import { sanitizeValueToI18nKey } from '../i18n.utils.js';
import { CONSOSTYLE_MACRO_SEGMENT_ORDER, CONSOSTYLE_MICRO_SEGMENT_ORDER, LIFESTAGE_MACRO_SEGMENT_ORDER, LIFESTAGE_MICRO_SEGMENT_ORDER, SEGMENT_KEY } from './segment-keys.js';
const NO_SEGMENT_KEY = SEGMENT_KEY.NO_SEGMENT;
const OTHERS_KEY = SEGMENT_KEY.OTHERS;
const KNOWN_BUCKET = 0;
const UNKNOWN_BUCKET = 1;
const NO_SEGMENT_BUCKET = 2;
const OTHERS_BUCKET = 3;
const getOrderArray = (segmentationType, granularity) => {
    const isMacro = granularity === CUSTOMER_SEGMENTATION_GRANULARITY_VIEWS.MACRO;
    if (segmentationType === CUSTOMER_SEGMENTATION_TYPES.LIFESTAGE) {
        return isMacro ? LIFESTAGE_MACRO_SEGMENT_ORDER : LIFESTAGE_MICRO_SEGMENT_ORDER;
    }
    return isMacro ? CONSOSTYLE_MACRO_SEGMENT_ORDER : CONSOSTYLE_MICRO_SEGMENT_ORDER;
};
const bucketFor = (rawKey, order) => {
    const normalized = sanitizeValueToI18nKey(rawKey);
    if (normalized === NO_SEGMENT_KEY) {
        return { bucket: NO_SEGMENT_BUCKET, subIndex: 0, normalized };
    }
    if (normalized === OTHERS_KEY) {
        return { bucket: OTHERS_BUCKET, subIndex: 0, normalized };
    }
    const knownIndex = order.indexOf(normalized);
    if (knownIndex >= 0) {
        return { bucket: KNOWN_BUCKET, subIndex: knownIndex, normalized };
    }
    return { bucket: UNKNOWN_BUCKET, subIndex: 0, normalized };
};
/**
 * Comparator for segment keys/descs at a given granularity: known segments follow the
 * business order, unknown ones fall back to alphabetical, and `no_segment` then `others`
 * are always pushed to the very end. Inputs are normalized, so raw labels and i18n keys
 * are both accepted.
 */
export const compareCustomerSegmentByKey = (a, b, segmentationType, granularity) => {
    const order = getOrderArray(segmentationType, granularity);
    const ca = bucketFor(a, order);
    const cb = bucketFor(b, order);
    if (ca.bucket !== cb.bucket) {
        return ca.bucket - cb.bucket;
    }
    if (ca.bucket === KNOWN_BUCKET) {
        return ca.subIndex - cb.subIndex;
    }
    return ca.normalized.localeCompare(cb.normalized);
};
//# sourceMappingURL=segment-order.js.map